import { ListItem } from '@/views/components/GuideRemind/js/type'
import { setNewbieFinish } from '@/api/index-page'
import { NEWBIE_FINISH_TYPE_ENUM } from '@/api/index-page/type'
import { setIsNewbieGuideFinished, getRemindHtml } from '.'

export function finishIndexPageGuide() {
  setNewbieFinish({ type: NEWBIE_FINISH_TYPE_ENUM.ISUPPLIER })
  setIsNewbieGuideFinished(true)
}

export function getGuideRemindConfig() {
  const lists: ListItem[] = [
    {
      selector: '.index-operating-data-card',
      remindHtml: getRemindHtml(
        '首页-经营数据板块',
        '展示供货金额与订单满足率。实销实结模式，更可直接查看可提现金额，便捷管理资金。',
        { maxWidth: 320 }
      ),
      positionY: 'top',
      spotPointLists: [
        {
          type: 'scale',
          xValue: 0.5,
          yValue: 0.9
        }
      ]
    },
    {
      selector: '.index-todo-list',
      remindHtml: getRemindHtml(
        '新首页-待办事项',
        '不再错过任何重要事务！我们将相关待办进行了聚合。点击数字即可快速跳转处理。',
        { maxWidth: 320 }
      ),
      positionY: 'top',
      scrollToView: true,
      spotPointLists: [
        {
          type: 'scale',
          xValue: 0.5,
          yValue: 0.1
        }
      ]
    },
    {
      selector: '.index-call-notice',
      remindHtml: getRemindHtml(
        '新首页-报价公告',
        '掌握最新采购报价机会，不错过任何商机。同时关注报价转化成果与商品对码状态，及时维护以提升合作效率。',
        { maxWidth: 320 }
      ),
      positionY: 'top',
      scrollToView: true,
      spotPointLists: [
        {
          type: 'scale',
          xValue: 0.5,
          yValue: 0.1
        }
      ],
      beforeCurStepFun: async () => {
        let callNoticeDom = document.querySelector('.index-call-notice')
        if (callNoticeDom) {
          callNoticeDom.scrollIntoView({ behavior: 'instant', block: 'end' })
          const p = new Promise((resolve) => {
            setTimeout(() => {
              resolve(true)
            }, 60)
          })
          await p
        }
        callNoticeDom = null
      }
    }
  ]
  return {
    lists,
    skipCallBackFun: () => {
      finishIndexPageGuide()
    },
    pageCompleteCallBackFun: () => {
      finishIndexPageGuide()
    },
    isLastPage: true
  }
}

export const INDEX_PAGE_GUIDE_KEY = 'useIndexPageGuide'
